import React, { Fragment, useEffect, useState } from "react";

import { getAllIndianCases } from "../slices/allIndia";
import { getAllStatesCases } from "../slices/allStates";

import { options } from "../variables/options";
import NotificationAlert from "react-notification-alert";
import "../assets/css/dashboard.css";

import { Bar, Pie } from "react-chartjs-2";

import fmt from "indian-number-format";

// reactstrap components
import {
  CardText,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";

import { useDispatch, useSelector, shallowEqual } from "react-redux";

const Dashbboard = () => {
  useEffect(() => {
    dispatch(getAllIndianCases());
    dispatch(getAllStatesCases());
    //eslint-disable-next-line
  }, []);

  let graph1 = {
    data: (canvas) => {
      let ctx = canvas.getContext("2d");

      let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

      gradientStroke.addColorStop(1, "rgba(72,72,176,0.1)");
      gradientStroke.addColorStop(0.4, "rgba(72,72,176,0.0)");
      gradientStroke.addColorStop(0, "rgba(119,52,169,0)"); //purple colors

      return {
        labels: ["Confirmed", "Recovered"],
        datasets: [
          {
            label: "India",
            fill: true,
            backgroundColor: gradientStroke,
            hoverBackgroundColor: gradientStroke,
            borderColor: "#d048b6",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            data: [allIndia.confirmed.value, allIndia.recovered.value],
          },
        ],
      };
    },
    options,
  };

  let graph2 = {
    data: (canvas) => {
      let ctx = canvas.getContext("2d");

      let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

      gradientStroke.addColorStop(1, "rgba(72,72,176,0.1)");
      gradientStroke.addColorStop(0.4, "rgba(72,72,176,0.0)");
      gradientStroke.addColorStop(0, "rgba(119,52,169,0)"); //purple colors

      return {
        labels: ["Active", "Deceased"],
        datasets: [
          {
            label: "India",
            fill: true,
            backgroundColor: gradientStroke,
            hoverBackgroundColor: gradientStroke,
            borderColor: "#FF9F89",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            data: [
              allIndia.confirmed.value -
                allIndia.deaths.value -
                allIndia.recovered.value,
              allIndia.deaths.value,
            ],
          },
        ],
      };
    },
    options,
  };

  const dispatch = useDispatch();
  const { allStates, allIndia } = useSelector((state) => {
    return {
      allStates: state.allStates.allStates,
      allIndia: state.allIndia.allCases,
    };
  }, shallowEqual);
  const notificationAlertRef = React.useRef(null);
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);
  const [modalContent, setModalContent] = useState(null);
  const onClick = async (id) => {
    let state = await allStates.find((singleState) => singleState.uid === id);
    await setModalContent(state);
    toggle();
  };
  return (
    <>
      <div className="content">
        <div className="react-notification-alert-container">
          <NotificationAlert ref={notificationAlertRef} />
        </div>
        <Row>
          <Col className="text-center" md={12}>
            <h1>INDIA</h1>
            {modalContent !== null && (
              <Modal size="lg" isOpen={modal} toggle={toggle}>
                <ModalHeader tag="h3" toggle={toggle}>
                  {modalContent.provinceState}
                </ModalHeader>
                <ModalBody>
                  <Row>
                    <Col sm="3" md="3">
                      <Card body inverse color="info">
                        <CardTitle className="text-center" tag="h6">
                          <strong>Confirmed</strong>
                        </CardTitle>
                        <CardText tag="h5" className="text-center">
                          <b>{fmt.format(modalContent.confirmed)}</b>
                        </CardText>
                      </Card>
                    </Col>
                    <Col sm="3" md="3">
                      <Card body inverse color="warning">
                        <CardTitle className="text-center" tag="h6">
                          <strong>Active</strong>
                        </CardTitle>
                        <CardText tag="h5" className="text-center">
                          <b>
                            {fmt.format(
                              modalContent.confirmed -
                                modalContent.recovered -
                                modalContent.deaths
                            )}
                          </b>
                        </CardText>
                      </Card>
                    </Col>
                    <Col sm="3" md="3">
                      <Card body inverse color="success">
                        <CardTitle className="text-center" tag="h6">
                          <strong>Recovered</strong>
                        </CardTitle>
                        <CardText tag="h5" className="text-center">
                          <b>{fmt.format(modalContent.recovered)}</b>
                        </CardText>
                      </Card>
                    </Col>
                    <Col sm="3" md="3">
                      <Card body inverse color="danger">
                        <CardTitle className="text-center" tag="h6">
                          <strong>Deceased</strong>
                        </CardTitle>
                        <CardText tag="h5" className="text-center">
                          <b>{fmt.format(modalContent.deaths)}</b>
                        </CardText>
                      </Card>
                    </Col>
                  </Row>
                  <Row>
                    <Pie
                      height={70}
                      data={{
                        labels: ["Active", "Recovered", "Deceased"],
                        datasets: [
                          {
                            data: [
                              modalContent.active,
                              modalContent.recovered,
                              modalContent.deaths,
                            ],
                            backgroundColor: ["#ff8d72", "#0cf2c2", "#fe5d93"],
                          },
                        ],
                      }}
                    />
                  </Row>
                  <Row>
                    Active :{" "}
                    <b>
                      {"  "}
                      {(
                        (modalContent.active * 100) /
                        modalContent.confirmed
                      ).toFixed(2)}{" "}
                      %
                    </b>
                  </Row>
                  <Row>
                    Recovered :{" "}
                    <b>
                      {(
                        (modalContent.recovered * 100) /
                        modalContent.confirmed
                      ).toFixed(2)}{" "}
                      %
                    </b>
                  </Row>
                  <Row>
                    Deceased :{" "}
                    <b>
                      {" "}
                      {(
                        (modalContent.deaths * 100) /
                        modalContent.confirmed
                      ).toFixed(2)}{" "}
                      %
                    </b>
                  </Row>
                </ModalBody>
              </Modal>
            )}
          </Col>
        </Row>
        <Row>
          {allIndia !== null && (
            <Fragment>
              <Col sm="3" md="3">
                <Card body inverse color="info">
                  <CardTitle className="text-center" tag="h4">
                    <strong>Confirmed</strong>
                  </CardTitle>
                  <CardText tag="h3" className="text-center">
                    <b>{fmt.format(allIndia.confirmed.value)}</b>
                  </CardText>
                </Card>
              </Col>
              <Col sm="3" md="3">
                <Card body inverse color="warning">
                  <CardTitle className="text-center" tag="h4">
                    <strong>Active</strong>
                  </CardTitle>
                  <CardText tag="h3" className="text-center">
                    <b>
                      {fmt.format(
                        allIndia.confirmed.value -
                          allIndia.recovered.value -
                          allIndia.deaths.value
                      )}
                    </b>
                  </CardText>
                </Card>
              </Col>
              <Col sm="3" md="3">
                <Card body inverse color="success">
                  <CardTitle className="text-center" tag="h4">
                    <strong>Recovered</strong>
                  </CardTitle>
                  <CardText tag="h3" className="text-center">
                    <b>{fmt.format(allIndia.recovered.value)}</b>
                  </CardText>
                </Card>
              </Col>
              <Col sm="3" md="3">
                <Card body inverse color="danger">
                  <CardTitle className="text-center" tag="h4">
                    <strong>Deceased</strong>
                  </CardTitle>
                  <CardText tag="h3" className="text-center">
                    <b>{fmt.format(allIndia.deaths.value)}</b>
                  </CardText>
                </Card>
              </Col>
              <Col md="6">
                <Card className="card-chart text-center">
                  <CardHeader>
                    <CardTitle tag="h3">Confirmed vs Recovered</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <div className="chart-area">
                      <Bar data={graph1.data} options={graph1.options} />
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md="6">
                <Card className="card-chart text-center">
                  <CardHeader>
                    <CardTitle tag="h3">Active vs Deceased</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <div className="chart-area">
                      <Bar data={graph2.data} options={graph2.options} />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Fragment>
          )}
        </Row>
        {/* <Row> */}
        <div style={{ margin: "50px auto" }}>
          {allStates !== null && (
            <Fragment>
              <h6 style={{ margin: "20px 0", color: "#fe5d93" }}>
                * click on a state/ut for details
              </h6>
              <Table responsive align="center" hover>
                <thead>
                  <tr>
                    <th>State/UT</th>
                    <th style={{ color: "#1a8df7" }}>Confirmed</th>
                    <th style={{ color: "#ff8d72" }}>Active</th>
                    <th style={{ color: "#0cf2c2" }}>Recovered</th>
                    <th style={{ color: "#fe5d93" }}>Deceased</th>
                  </tr>
                </thead>
                <tbody>
                  {allStates.map((state) => {
                    return (
                      <tr key={state.uid}>
                        <td
                          onClick={() => onClick(state.uid)}
                          className="custom"
                        >
                          {state.provinceState}{" "}
                          <i className="tim-icons icon-alert-circle-exc" />
                        </td>
                        <th style={{ color: "#1a8df7" }}>
                          {fmt.format(state.confirmed)}
                        </th>
                        <th style={{ color: "#ff8d72" }}>
                          {fmt.format(state.active)}
                        </th>
                        <th style={{ color: "#0cf2c2" }}>
                          {fmt.format(state.recovered)}
                        </th>
                        <th style={{ color: "#fe5d93" }}>
                          {fmt.format(state.deaths)}
                        </th>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Fragment>
          )}
          {/* </Row> */}
        </div>
      </div>
    </>
  );
};

export default Dashbboard;
